import { Component, OnInit } from '@angular/core';
import { AbstractControl, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { Client } from 'src/app/shared/models/client';
import { ClientService } from 'src/app/shared/services/client.service';
import { showFeedbackSuccess } from 'src/app/shared/util/alert-swal';
import { SeoService } from 'src/app/shared/util/seo.service';
import { SessionManager } from 'src/app/shared/util/session-manager';
import { SsrUtilService } from 'src/app/shared/util/ssr-util.service';
import { PAGE_TITLE, checkPhoneSintax } from 'src/globals';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-form',
  templateUrl: './form.component.html',
  styleUrls: ['./form.component.scss'],
})
export class FormComponent implements OnInit {
  title: string = 'Cadastre-se';
  redirectUrl: string = '/login';
  isMyData: boolean = false;
  client: Client;
  fmGroup: UntypedFormGroup;

  constructor(
    private ssr: SsrUtilService,
    private route: ActivatedRoute,
    private router: Router,
    private titleService: Title,
    private seo: SeoService,
    private sm: SessionManager,
    private formBuilder: UntypedFormBuilder,
    private clientService: ClientService
  ) {
    this.isMyData = this.sm.hasToken();
    this.createForm();
  }

  createForm() {
    this.fmGroup = this.formBuilder.group(
      {
        name: [null, Validators.required],
        cpf: [null, Validators.minLength(14)],
        phone: [
          null,
          Validators.required,
          Validators.minLength(14),
          Validators.maxLength(15),
          Validators.compose([checkPhoneSintax]),
        ],
        email: [null, Validators.required, Validators.email],
        pwd: [null, this.isMyData ? null : Validators.required],
        repeatPwd: [null, this.isMyData ? null : Validators.required],
      },
      {
        validator: (c: AbstractControl) => {
          const error = { passwordMustMatch: true };
          if (c.get('pwd').value === c.get('repeatPwd').value) return null;
          else {
            c.get('repeatPwd').setErrors(error);
            return error;
          }
        },
      }
    );
  }

  ngOnInit(): void {
    this.titleService.setTitle(`${this.title} - ${PAGE_TITLE}`);

    // Adiciona/Atualiza as Tags ao head da pagina
    this.seo.addTitle(this.titleService.getTitle());

    // se houver redirectUrl, usa
    this.route.queryParams.subscribe(params => {
      const { redirectUrl } = params;
      if (redirectUrl) this.redirectUrl = redirectUrl;
    });

    //
    if (this.isMyData) {
      this.redirectUrl = '/meus-dados';
      this.clientService.getMyData().subscribe(
        result => {
          this.client = result;
          this.fmGroup.patchValue({
            name: result?.nome,
            cpf: result?.cpf,
            phone: result?.telefone,
            email: result?.email,
          });
        },
        error => {
          SessionManager.handleHttpError(error, 'Não foi possível buscar seus dados');
        }
      );
    }
  }

  onSend() {
    // Valida os campos do form
    if (this.fmGroup.invalid) return;

    const { name, cpf, phone, email, repeatPwd } = this.fmGroup.value;
    if (!this.client) this.client = new Client();
    this.client.nome = name;
    this.client.cpf = cpf;
    this.client.telefone = phone;
    this.client.email = email;
    this.client.novaSenha = repeatPwd;

    if (this.client?.id || 0 > 0) this.update(this.client);
    else this.insert(this.client);
  }

  insert(c: Client) {
    this.clientService.insert(this.client).subscribe(
      () => {
        showFeedbackSuccess('Dados salvos com sucesso').then(() => this.router.navigateByUrl(this.redirectUrl));
      },
      error => {
        SessionManager.handleHttpError(error, 'Não foi possível enviar seus dados');
      }
    );
  }

  update(c: Client) {
    this.clientService.update(this.client).subscribe(
      () => {
        showFeedbackSuccess('Dados salvos com sucesso')
          // .then(() => this.router.navigateByUrl(this.redirectUrl))
          .then(() => (this.ssr.getLocation().href = this.redirectUrl));
      },
      error => {
        SessionManager.handleHttpError(error, 'Não foi possível enviar seus dados');
      }
    );
  }

  onRemove() {
    Swal.fire({
      title: 'Confirme a sua opção',
      text: 'Esta ação é permanente.',
      showCancelButton: true,
      confirmButtonText: 'Sim, desejo remover',
      cancelButtonText: 'Cancelar',
      allowOutsideClick: () => !Swal.isLoading(),
    }).then(result => {
      if (result.isConfirmed)
        this.clientService.delete().subscribe(
          () => {
            showFeedbackSuccess('Operação realizada com sucesso').then(() => {
              this.sm.logout();
              this.ssr.getLocation().href = '/home';
            });
          },
          error => {
            SessionManager.handleHttpError(error, 'Não foi possível realizar sua solicitação');
          }
        );
    });
  }
}
